import { HeaderTextProps } from 'components/organisms/Header/types';

const header: HeaderTextProps = {
    headerText: {
        greetings: '你好',
        intro: "我是",
        preTitle: '一个',
    },
    scrollDown: '向下滚动',
};

export default header;
